module.exports = __webpack_public_path__ + "media/images/mamari/wowma/flow-bg-pink-0a890b77edcc9675c35e957bc87c66c6.png";